<template>
  <Modal :open.sync="open" size="large">
    <Chooser v-if="!tab" :value.sync="tab" />
    <LibrarySelector v-else-if="tab == 'library'" :value.sync="tab" />
    <TeamLibrarySelector v-else :value.sync="tab" />
  </Modal>
</template>

<script>
import { sync } from "vuex-pathify";
import Modal from "@/components/ui/Modal.vue";
import VButton from "@/components/ui/VButton.vue";
import Chooser from "./ImportListChooser.vue";
import LibrarySelector from "./LibrarySelector.vue";
import TeamLibrarySelector from "./TeamLibrarySelector.vue";

export default {
  components: {
    Modal,
    VButton,
    Chooser,
    LibrarySelector,
    TeamLibrarySelector,
  },

  computed: {
    open: sync("ui/modal@list.import.open"),
    tab: sync("ui/modal@list.import.tab"),
  },
};
</script>